import { render, staticRenderFns } from "./imageTxtDetails.vue?vue&type=template&id=4f3dd264&scoped=true"
import script from "./imageTxtDetails.vue?vue&type=script&lang=js"
export * from "./imageTxtDetails.vue?vue&type=script&lang=js"
import style0 from "./imageTxtDetails.vue?vue&type=style&index=0&id=4f3dd264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3dd264",
  null
  
)

export default component.exports